let origin = window.ORIGIN;
//创业达人列表
const getTalentListUrl = `${origin}/gateway/hc-neighbour/topic/getTopicList`;

// 创业达人详情
const getTalentInfoByIdURL = `${origin}/gateway/hc-neighbour/topic/getTopicInfoById`;
export { getTalentListUrl, getTalentInfoByIdURL };
